import { localizeParam, matchParam } from '$lib/i18n-url';

const localizedParam = localizeParam(2, 'l_privacy', {
	en: 'privacy-statement',
	de: 'datenschutz'
});

export const match = (param) => matchParam(param, localizedParam);
